import { getPrimaryEnrollment } from './studentEnrollmentStatus';

/**
 * Apply batchStatus to the matching enrollment in local student list state.
 */
export function patchStudentEnrollmentStatus(students, studentId, enrollmentId, batchStatus) {
  const sid = String(studentId);
  const eid = String(enrollmentId);

  return students.map((student) => {
    if (String(student.id || student._id) !== sid) return student;
    if (!Array.isArray(student.enrollments)) return student;

    return {
      ...student,
      enrollments: student.enrollments.map((en) =>
        String(en.id) === eid ? { ...en, batchStatus } : en
      ),
    };
  });
}

/**
 * @param {Array} students
 * @param {string} batchStatus
 */
export function countStudentsUpdatableForStatus(students, batchStatus) {
  return students.filter((student) => {
    const enrollment = getPrimaryEnrollment(student);
    if (!enrollment?.id) return false;
    return enrollment.batchStatus !== batchStatus;
  }).length;
}
